import React from "react";
import LoadingSpin from "../../components/LoadingSpin";
import {BrowserRouter as Router, Link} from "react-router-dom";
import Helmet from "react-helmet";
import ErrorMessage from "../../components/ErrorMessage";
import {config} from "../../components/Constants";

class SupportList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            tasks: []
        };
    }

    componentDidMount() {
        this.setState({
            tasks: [],
            isLoaded: true,
        });
    }

    render() {
        const {error, isLoaded, tasks} = this.state;
        const that = this;
        if (!isLoaded) {
            return (
                <LoadingSpin/>
            );
        } else if (error) {
            return (
                <ErrorMessage title="Pojawiły się błędy" text={error} buttons={[
                    {'title': 'Powrót', 'callback': function() {that.setState({redirect: '/tasks', error: null});}}
                ]} handleClose={() => {that.setState({redirect: '/tasks', error: null});}}/>
            );
        } else {
            return (
                <React.Fragment>
                    <Helmet>
                        <title>Zgłoszenia klientów</title>
                    </Helmet>
                    <header className="clients-header">
                        <h1>Zgłoszenia klientów</h1>
                    </header>
                    <div className="section-div">
                    </div>
                </React.Fragment>
            );
        }
    }
}

export default SupportList;